export default __webpack_public_path__ + "static/media/03.98677903.png";